import React from 'react';
import { Box, Stack, Tooltip, Typography } from '@mui/material';
import { ArrowBack, Circle } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import { goBackInApp } from '../../utils/navigation';
import { IconButton } from '../ui/ConvivialComponents';

const Header = ({
    title,
    backPath = -1,
    statusIcon = false,
    topRightText = false,
    topRightAction = false,
    noGoBack = false,
}) => {
    const navigate = useNavigate();

    return (
        <Box
            sx={{
                position: 'fixed',
                top: 0,
                left: 0,
                right: 0,
                zIndex: 50,
                height: 'var(--cv-top-bar-height)',
                bgcolor: 'rgba(252, 249, 245, 0.94)',
                backdropFilter: 'blur(14px)',
                borderBottom: '1px solid rgba(223, 191, 193, 0.3)',
                boxShadow: '0 2px 12px rgba(29, 29, 27, 0.04)',
            }}
        >
            <Stack direction="row" alignItems="center" justifyContent="space-between" sx={{ height: '100%', maxWidth: 1200, mx: 'auto', px: 2 }}>
                {!noGoBack ? (
                    <IconButton label="Indietro" onClick={() => backPath === -1 ? goBackInApp(navigate) : navigate(backPath)}>
                        <ArrowBack />
                    </IconButton>
                ) : (
                    <Box sx={{ width: 44 }} />
                )}
                <Typography variant="h3" sx={{ color: 'primary.main', textAlign: 'center', flex: 1, fontSize: { xs: 22, sm: 24 } }}>
                    {title}
                </Typography>
                {topRightText ? (
                    <Typography
                        variant="button"
                        sx={{ color: 'primary.main', cursor: 'pointer', minWidth: 44, textAlign: 'right' }}
                        onClick={topRightAction}
                    >
                        {topRightText}
                    </Typography>
                ) : statusIcon ? (
                    <Tooltip title={statusIcon}>
                        <Box sx={{ width: 44, display: 'flex', justifyContent: 'center' }}>
                            {statusIcon !== 'undefined' && (
                                <Circle
                                    sx={{
                                        color: statusIcon === 'terminato' ? 'error.main' : statusIcon === 'in corso' ? '#008000' : '#FFA500',
                                        animation: statusIcon === 'in corso' ? 'blinking 2s infinite' : 'none',
                                        '@keyframes blinking': {
                                            '0%': { opacity: 1 },
                                            '50%': { opacity: 0.35 },
                                            '100%': { opacity: 1 },
                                        },
                                    }}
                                />
                            )}
                        </Box>
                    </Tooltip>
                ) : (
                    <Box sx={{ width: 44 }} />
                )}
            </Stack>
        </Box>
    );
};

export default Header;
